import { useEffect, useState } from 'react';
import axios from 'axios';
import { Form, Button, Row, Col } from 'react-bootstrap';

const API_BASE_URL =  process.env.REACT_APP_API_BASE_URL;

const MeasurementCategoriesForm = ({ onSubmit, initialData = null, onCancel, auth, onLogout }) => {
    const [typeName, setTypeName] = useState('');
    const [description, setDescription] = useState('');
    const [error, setError] = useState(null);

    useEffect(() => {
        if (initialData) {
            setTypeName(initialData.type_name || '');
            setDescription(initialData.measurement_description || '');
        } else {
            setTypeName('');
            setDescription('');
        }
    }, [initialData]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!typeName.trim()) {
            setError("Type name is required");
            return;
        }

        setError(null);

        const category = {
            type_name: typeName,
            measurement_description: description || null,
            created_at: initialData?.created_at,
            updated_at: initialData ? initialData : null,
        };

        try {
            const headers = { Authorization: `Bearer ${auth.token}` }; // authorization header
            let response;
            if (initialData) {
                // Update existing category
                response = await axios.put(`${API_BASE_URL}/measurement-categories/${initialData.id}`, category, { headers });
            } else {
                // Add new category
                response = await axios.post(`${API_BASE_URL}/measurement-categories`, category, { headers });
            }

            // console.log('Category saved successfully:', response.data);
            onSubmit(response.data);
        } catch (error) {
            // console.error('Error saving category:', error.message);
            alert('Failed to save measurement type. Please try again.');

            if (error.response?.status === 401) {
                onLogout(); // Trigger logout on 401 error
            } else {
                setError(error.response?.data?.message || "Failed to save measurement type. Please try again.");
            }
        }

        setTypeName('');
        setDescription('');
    };

    return (
        <Form onSubmit={handleSubmit} className="mb-2" style={{maxWidth: "1000px"}}>
            <h4>{initialData ? 'Edit Measurement Type' : 'Add Measurement Type'}</h4>

            <Form.Group className="mb-4 mt-3" controlId="typeName">
                <Form.Label>Type Name*</Form.Label>
                <Form.Control
                    type="text"
                    value={typeName}
                    onChange={(e) => setTypeName(e.target.value)}
                    placeholder="Enter type name"
                    required
                />
            </Form.Group>

            <Form.Group className="mb-4" controlId="description">
                <Form.Label>Description</Form.Label>
                <Form.Control
                    as="textarea"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    placeholder="Enter description (optional)"
                />
            </Form.Group>

            <Row>
                <Col xs="auto">
                    <Button variant="primary" type="submit">
                        {initialData ? 'Update' : 'Add'}
                    </Button>
                </Col>
                <Col xs="auto">
                    <Button variant="secondary" type="button" onClick={onCancel}>
                        Cancel
                    </Button>
                </Col>
            </Row>
        </Form>
    );
};

export default MeasurementCategoriesForm;